export default "__VITE_ASSET__C$06Zdb5__"